import { supabase } from '@/core/database/supabase';
import type { EstimateItemResource } from '../types/estimate.types';

function normalizeResource(row: any): EstimateItemResource {
  return {
    id: row.id,
    company_id: row.company_id,
    project_id: row.project_id,
    estimate_id: row.estimate_id,
    estimate_item_id: row.estimate_item_id,
    resource_type: row.resource_type,
    resource_id: row.resource_id,
    resource_code: row.resource_code,
    resource_name: row.resource_name,
    unit: row.unit,
    norm_quantity: Number(row.norm_quantity || 0),
    quantity: Number(row.quantity || 0),
    waste_factor: Number(row.waste_factor || 0),
    unit_price: Number(row.unit_price || 0),
    total_amount: Number(row.total_amount || 0),
    price_source: row.price_source,
    note: row.note,
    created_at: row.created_at,
  };
}

export const estimateResourcesService = {
  async getByEstimateId(estimateId: string): Promise<EstimateItemResource[]> {
    const { data, error } = await supabase
      .from('estimate_item_resources' as any)
      .select('*')
      .eq('estimate_id', estimateId)
      .order('created_at', { ascending: true });

    if (error) {
      const missingTable = error.code === '42P01' || error.message?.includes('estimate_item_resources');
      if (missingTable) return [];
      throw error;
    }

    return ((data || []) as any[]).map(normalizeResource);
  },

  async getByItemId(itemId: string): Promise<EstimateItemResource[]> {
    const { data, error } = await supabase
      .from('estimate_item_resources' as any)
      .select('*')
      .eq('estimate_item_id', itemId)
      .order('created_at', { ascending: true });

    if (error) {
      const missingTable = error.code === '42P01' || error.message?.includes('estimate_item_resources');
      if (missingTable) return [];
      throw error;
    }

    return ((data || []) as any[]).map(normalizeResource);
  },
};
